import React from "react";
import logo from "../assets/Logomain.jpg";

function Header({ right }) {
  return (
    <div className="header">
      <div className="header__logo">
        <img src={logo} alt="CareNest Logo" />
        <div>
          <div className="header__company">
            CareNest <span className="highlight">Services</span>
          </div>
          <div className="header__caption">
            Making every home a Nest of Support.
          </div>
        </div>
      </div>
      {/* Renders right-side content: contacts (desktop), burger (mobile) */}
      <div className="header__right">{right}</div>
    </div>
  );
}

export default Header;
